import { FILL_FORM_WITH_AI } from '../store/state/actions/index';
import type { Action } from '../store/state/state-manager';

import refreshConstants from './index';
// Action creators for the refresh actions

/**
 * [refreshData]
 * Description : Returns the action object for the REFRESH_DATA action.
 * @param payload         - payload to the epic
 * @returns Action object
 *                      object.type     - REFRESH_DATA
 *                      object.payload  - payload
 */
export const refreshData = (payload: Action['payload']) => {
  return {
    type: refreshConstants.REFRESH_DATA,
    payload
  };
};

export const fillFormWithAI = (payload: Action['payload']) => {
  return {
    type: FILL_FORM_WITH_AI,
    payload
  };
};
